export default "__VITE_ASSET__f1e8712b__"